import React from "react";
import dayjs from "dayjs";
import './styles.scss'
import {Table, Text} from "@mantine/core";
import {IDocumentDetailsData} from "../../../api/Shipment.DocumentDetails/Shipment.DocumentDetails.types";
import { upload } from "@testing-library/user-event/dist/upload";

interface Props {
    documents: IDocumentDetailsData[],
    onDocumentClick: (document:IDocumentDetailsData)=>void,
}

function DocumentDetails(props: Props) {
    const {documents, onDocumentClick} = props;
    const rows = documents.map((document) => {
        const {
            id,
            docId,
            refId,
            docName,
            fileName,
            fileFolder,
            docType,
            remarks,
            uploadBy,
            ieOrTrk,
            createDate,
            firstName,
            lastName
        } = document;

        return (
            <tr key={id}>
                {<td><Text variant="link" size="sm" color="blue" sx={() => ({"&:hover": {cursor: "pointer"}})}
            onClick={() => onDocumentClick(document)}>{docName}</Text></td> }
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{docType}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{firstName} {lastName}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{createDate}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{remarks}</td>
                

            </tr>
        )
    });

    return (
        <Table striped>
            <thead>
            <tr>
                <th>Doc Name</th>
                <th>Doc Type</th>
                <th>Upload By</th>
                <th>Upload Date</th>                
                <th>Remarks</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )
}

export default DocumentDetails;